module.exports = __webpack_public_path__ + "static/img_5062-6350baa326c1190c001166726fa4b4c8.webp";